import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import HubspotInputGroup from './HubspotInputGroup';
import reportWebVitals from './reportWebVitals';

const HUBSPOT_INPUTGROUP = ReactDOM.createRoot(document.getElementById('APP_HUBSPOT_INPUTGROUP'));
const appElement = document.getElementById("APP_HUBSPOT_INPUTGROUP");
if( appElement ){
  const portalId = appElement.getAttribute("portalId");
  const formId = appElement.getAttribute("formId"); // Retrieve formId if needed
  HUBSPOT_INPUTGROUP.render(
    <React.StrictMode>
      <HubspotInputGroup portalId={portalId} formId={formId}/>
    </React.StrictMode>
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
